import { get, trim } from 'lodash';

class Screen {
  constructor() {
    this.screenMap = {
      smap_no: 'Id',
      smap_desc: 'Description',
      screen_no: 'Id',
      screen_desc: 'Description',
      num_rows: 'RowCount',
      num_cols: 'ColumnCount',
      screen_up: 'ScreenUp',
      screen_down: 'ScreenDown',
      screen_left: 'ScreenLeft',
      screen_right: 'ScreenRight'
    };
  }

  map(screens) {
    if (screens === undefined) {
      return [];
    }
    let theScreens = [];
    for (let x = 0; x < screens.length; x++) {
      let screen = {};
      for (let p in this.screenMap) {
        screen[p] = trim(get(screens[x], this.screenMap[p]));
      }
      theScreens.push(screen);
    }

    return theScreens;
  }
}

export default Screen;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/Screen.js